export interface Brand {
  id: number
  code: string
  name: string
}

export type BrandCode = string | null

// ブランドコード定数
export const BRAND_CODES = {
  ROOTC: 'rootc' as const,
  SBJ: 'sbj' as const,
} as const

// デフォルトブランドコード
export const DEFAULT_BRAND_CODE = BRAND_CODES.ROOTC

// ロールに基づくデフォルトブランドコード取得
export const getDefaultBrandCodeByRole = (isSbjUser: boolean): BrandCode => {
  return isSbjUser ? BRAND_CODES.SBJ : BRAND_CODES.ROOTC
}
